/**
 * SGKC030A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AjstnkInfoDto {

    /**
     * 調整単価種別コード
     */
    ajstnkClscode?: string;
    /**
     * 調整単価種別名称
     */
    ajstnkClsname?: string;
    /**
     * 調整単価
     */
    choseiTanka?: number;
}

